
export default function ControlService() {

    var service = {
    };


    return service;
}
